/*code reference from @material_ui component Dialog https://material-ui.com/components/dialogs/*/
import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from '@material-ui/core/styles';
import MuiDialog from '@material-ui/core/Dialog';
import TwoButtonLayout from "components/General/Form/CustomButton/TwoButtonLayout";

const CustomDialog = withStyles((theme) => ({
    paper: {
      borderRadius: "10px",
      padding: "8px",
    },
}))(MuiDialog);

function  CustomDecisionPopup (props) {
        return(
            <div>
                <CustomDialog
                    open = {true}
                    onClose = {()=>(props.declineButtonClick())}
                >
                    <DialogTitle>
                        <TextTheme
                            className = "text_bold text_medium text_dark_blue"
                            message = {props.popupTitle}
                        />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <TextTheme
                                className = "text_medium text_med_grey"
                                message = {props.popupDescription}
                            />
                        </DialogContentText>

                        {/*More text underneath the first is optional*/}
                        {props.popupDescription2 ? (
                              <DialogContentText>
                                    <TextTheme
                                        className = "text_medium text_med_grey"
                                        message = {props.popupDescription2}
                                    />
                              </DialogContentText>
                            ):(null)
                        }
                    </DialogContent>

                    <DialogActions>
                        {/*
                        <RoundedButton
                            title={props.declineButtonText}
                            textThemeClassName = "text_bold text_dark_orange text_small"
                            buttonClassName = "background_white"
                            border = "1px solid #ff431b"

                            handleOnClick = {()=>(props.declineButtonClick())}
                        />
                        <RoundedButton
                            title={props.acceptButtonText}
                            textThemeClassName = "text_bold text_white text_small"
                            buttonClassName = "background_dark_orange"
                            handleOnClick = {()=>(props.acceptButtonClick())}
                        />
                        */}
                        <div style = {{width: "100%"}}>
                            <TwoButtonLayout button1Text={props.declineButtonText} button2Text={props.acceptButtonText}
                                button1Click={()=>(props.declineButtonClick())}
                                button2Click={()=>(props.acceptButtonClick())}
                                marginLeft = "0%"
                                marginRight = "8%"
                                width = "100%"
                            />
                        </div>
                    </DialogActions>
                </CustomDialog>
            </div>
        );

}

export default CustomDecisionPopup;